import useMutationApi from 'src/api/useMutationApi';
import { Charge } from 'src/types/application/SalesOrderDraftDTO';

interface AddChargeBody {
  charge: Charge;
}

interface UpdateChargeBody {
  charge: Charge;
  chargeId: string;
}

interface DeleteChargeBody {
  chargeId: string;
}

// Add charge to sales order draft
export const useAddSalesOrderDraftCharge = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<AddChargeBody>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/charges`,
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

// Update charge on sales order draft
export const useUpdateSalesOrderDraftCharge = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<UpdateChargeBody>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/charges`,
    method: 'PUT',
    options: {
      onSuccess,
    },
  });
};

// Delete charge from sales order draft
export const useDeleteSalesOrderDraftCharge = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<DeleteChargeBody>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/charges`,
    method: 'DELETE',
    options: {
      onSuccess,
    },
  });
};
